<template>
  <v-app>
    <ReviewsDrawer
      v-if="hasReviews"
      v-model="reviewsDrawer"
      @close="reviewsDrawer = false"
    />

    <v-app-bar flat theme="dark">
      <template #prepend>
        <a href="/">
          <v-img
            :src="logo"
            aspect-ratio="1.36"
            class="mr-2"
            contain
            width="70"
          />
        </a>
      </template>

      <template #append>
        <v-btn
          color="primary"
          rounded="pill"
          variant="flat"
          @click="reviewsDrawer = !reviewsDrawer"
        >
          Reviews
        </v-btn>
      </template>
    </v-app-bar>

    <v-main>
      <slot />
    </v-main>

    <v-footer color="grey-darken-4">
      <FooterSection />
    </v-footer>
  </v-app>
</template>

<script setup>
import { ref } from 'vue'
import logo from '#root/assets/logos/logo-wwa.svg'

const reviewsDrawer = ref(false)
const hasReviews = !!import.meta.env.VITE_BROADLY_REVIEWS
</script>
